import { Actor, isViewOnlyModeAtom } from "@zapier/canvas-state";
import { useAtomValue } from "jotai";
import classNames from "classnames";

import useUpdateNode from "../../../hooks/useUpdateNode";
import { SidebarListItem } from "../SidebarListItem";

import styles from "./List.module.css";

export function ActorList({
  nodeId,
  actors = [],
}: {
  nodeId: string;
  actors: Actor[] | undefined;
}) {
  const isViewOnlyMode = useAtomValue(isViewOnlyModeAtom);
  const updateNodeAndSave = useUpdateNode();
  const actor = actors.find((actor) => actor.label === actors?.[0]?.label);
  function onRemoveActor() {
    updateNodeAndSave({
      id: nodeId,
      data: {
        actors: undefined,
      },
    });
  }

  if (!actor) {
    return null;
  }

  const listStyles = classNames(styles.actorList, {
    [styles.row]: isViewOnlyMode,
  });

  return (
    <ul className={listStyles}>
      <SidebarListItem
        key={actor.label}
        label={actor.label}
        color={actor.color}
        onRemove={isViewOnlyMode ? undefined : onRemoveActor}
        isViewOnly={isViewOnlyMode}
      />
    </ul>
  );
}
